// 全局 Toast 提示函数
export function showToast(message, type = 'info') {
  if (window.appInstance && window.appInstance.showGlobalToast) {
    window.appInstance.showGlobalToast(message, type)
  } else {
    console.log(`[Toast] [${type}] ${message}`)
  }
}

export async function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}